// --------------------------------------------
// Constants to be used in actions and reducers
// ---------------------------------------------
const PREFIX = 'KardiaRx.';
export const IDTF_PATIENTS_DATA_REQUEST = `${PREFIX}IDTF_PATIENTS_DATA_REQUEST`;
export const IDTF_PATIENTS_DATA_SUCCESS = `${PREFIX}IDTF_PATIENTS_DATA_SUCCESS`;
export const IDTF_PATIENTS_DATA_FAILURE = `${PREFIX}IDTF_PATIENTS_DATA_FAILURE`;

// Constants for KardiaRx IDTF ECG Table
export const IDTF_ECG_TABLE_DATA_REQUEST = `${PREFIX}IDTF_ECG_TABLE_DATA_REQUEST`;
export const IDTF_ECG_TABLE_DATA_SUCCESS = `${PREFIX}IDTF_ECG_TABLE_DATA_SUCCESS`;
export const IDTF_ECG_TABLE_DATA_FAILURE = `${PREFIX}IDTF_ECG_TABLE_DATA_FAILURE`;

// constants for kardiaRx IDTF ECG Confirm
export const IDTF_ECG_CONFIRM_REQUEST = `${PREFIX}IDTF_ECG_CONFIRM_REQUEST`;
export const IDTF_ECG_CONFIRM_SUCCESS = `${PREFIX}IDTF_ECG_CONFIRM_SUCCESS`;
export const IDTF_ECG_CONFIRM_FAILURE = `${PREFIX}IDTF_ECG_CONFIRM_FAILURE`;

// constants for selected patients
export const IDTF_SELECTED_PATIENT = `${PREFIX}IDTF_SELECTED_PATIENT`;

// constants for selected recordings
export const IDTF_SELECTED_RECORDING = `${PREFIX}IDTF_SELECTED_RECORDING`;

export const IDTF_PATIENTST_FILTER_DROPDOWN_VALUE_SUBMIT = `${PREFIX}IDTF_PATIENTST_FILTER_DROPDOWN_VALUE_SUBMIT`;

export const IDTF_PATIENTS_AUTO_COMPLETE_DATA_SUCCESS = `${PREFIX}IDTF_PATIENTS_AUTO_COMPLETE_DATA_SUCCESS`;



// WEBPACK FOOTER //
// ./src/views/state/kardiaRxIdtf/types.js